export default __webpack_public_path__ + "static/media/qaCode.d9e5d025.png";